import CityPageToldos from "../components/CityPageToldos";

export default function ToldosTorremolinos() {
  return (
    <CityPageToldos
      name="Torremolinos"
      slug="torremolinos"
      cp="29620"
      poblacion={71270}
      zonaGeo="Costa del Sol Occidental"
      lat={36.6203}
      lng={-4.4998}
      zonas={["La Carihuela", "Playamar", "Centro", "Montemar", "Bajondillo"]}
      landmarks={["Playa La Carihuela", "Plaza Costa del Sol", "Pueblo Blanco"]}
      municipiosLimitrofes={["Málaga", "Benalmádena", "Alhaurín de la Torre"]}
      festivalLocal="Feria de San Miguel, finales de septiembre"
      contextoTipologico="Restaurantes y chiringuitos La Carihuela con toldos comerciales grandes, apartamentos costeros con terrazas amplias, 121 nacionalidades residentes con alta exigencia."
      isCoreZone={true}
    />
  );
}